import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaLoyaltyProgramQualityKpi } from 'src/app/assabil-sales/models/dtos/geo-area-loyalty-program-quality-kpi';

@Component({
  selector: 'geo-area-loyalty-program-quality-kpi',
  templateUrl: './geo-area-loyalty-program-quality-kpi.component.html',
  styleUrls: ['./geo-area-loyalty-program-quality-kpi.component.scss']
})
export class GeoAreaLoyaltyProgramQualityKpiComponent implements OnInit {


  @Input() geoAreaLoyaltyProgramQualityKpi : GeoAreaLoyaltyProgramQualityKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaLoyaltyProgramQualityKpi.expanded = !this.geoAreaLoyaltyProgramQualityKpi.expanded;
  }
}